import React, {Component} from 'react';
import {List, Toast,NavBar,Modal} from 'antd-mobile';
import {getdetailes,orderSend,cancleCity} from "../../../../../service/cityService";
import {translate} from '../../../../../service/homeService';
import moment from "moment";
import BMap from "BMap";
import './index.less';
import {connect} from "react-redux";
//地图相关代码
const start = require('../../../../../common/image/start.png');
const end = require('../../../../../common/image/end.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class CityBill extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            showModal:false,
            closeModal:false,
            modal:false,
            show:true,//发单预览地址，默认是显示
            data:{},
            startAddressLocal:'',
            endAddressLocal:'',
            distance:'',
            id:'',
            orderNum:'',
        };
    }

    componentDidMount() {
        let params = {
            token: this.props.userInfo.token,
            data: {
                id: this.props.location.state.id
            }
        }
        getdetailes(params).then((res) => {
            let startAddressLocal = ""
            let endAddressLocal = ""
            if(res.data.code == "0000"){
              this.setState({
                  data:res.data.data,
                  startAddressLocal:res.data.data.startAddressLocal,
                  endAddressLocal:res.data.data.endAddressLocal,
              })
              this.convertjwd(res.data.data.startAddressLocation.split('_')[0],res.data.data.startAddressLocation.split('_')[1],5,(r)=>{
                startAddressLocal = r.split('_')
                this.convertjwd(res.data.data.endAddressLocation.split('_')[0],res.data.data.endAddressLocation.split('_')[1],5,(r)=>{
                    endAddressLocal = r.split('_')
                    let point1 = new BMap.Point(startAddressLocal[1],startAddressLocal[0]);  // 创建点坐标    
                    let point2 = new BMap.Point(endAddressLocal[1],endAddressLocal[0]); 
                    let driving = new BMap.DrivingRoute(map, {renderOptions:{map: map,autoViewport: true}});
                    driving.search(point1, point2);
                    let myIcon1 = new BMap.Icon(start, new BMap.Size(30,45));
                    let myIcon2 = new BMap.Icon(end, new BMap.Size(30,45));
                    driving.setMarkersSetCallback(function(result){
                        result[0].marker.setIcon(myIcon1);
                        result[1].marker.setIcon(myIcon2);
                    })
                    var output;
                    var searchComplete = function (results){
                        var plan = results.getPlan(0);
                        output = plan.getDistance(true);             //获取距离
                    }
                    var distance;
                    var transit = new BMap.DrivingRoute(map, {renderOptions: {map: map},
                        onSearchComplete: searchComplete,
                        onPolylinesSet: function(){        
                            distance = output
                    }});
                    transit.search(point1, point2);
                    transit.setMarkersSetCallback(function(result){
                        result[0].marker.setIcon(myIcon1);
                        result[1].marker.setIcon(myIcon2);
                    })
                    setTimeout(() => {
                        let opts = {
                            position : point1,    // 指定文本标注所在的地理位置
                            offset   : new BMap.Size(-54, -52)    //设置文本偏移量
                        }
                        let label = new BMap.Label(`<span style='color:#616372;padding-right:8px'>全程</span>`+ distance.slice(0, -2) + `<span style='color:#303030;padding-left:8px'>公里</span>`, opts);  // 创建文本标注对象
                        label.setStyle({
                            color : "#3679FE",
                            fontSize : "14px",
                            height : "20px",
                            lineHeight : "20px",
                            fontFamily:"微软雅黑",
                            borderRadius:"20px",
                            border:'none',
                            padding:'5px 10px',
                            boxShadow:'0px 3px 6px rgba(0,0,0,0.2)'
                        });
                        map.addOverlay(label);   
                    }, 1001);
                })
            })
            }else {
                Toast.info(res.data.msg,3)
            }
            }).catch(function (error) {
            console.log(error);
        });
        let map = new BMap.Map("allmap"); 
        map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
        map.enableContinuousZoom();  
        setTimeout(() => {
            let startAddressLocal = this.state.startAddressLocal.split('_')
            let endAddressLocal = this.state.endAddressLocal.split('_')
            if(startAddressLocal && this.state.startAddressLocal){              
                let point1 = new BMap.Point(startAddressLocal[1],startAddressLocal[0]);  // 创建点坐标    
                let point2 = new BMap.Point(endAddressLocal[1],endAddressLocal[0]); 
                let driving = new BMap.DrivingRoute(map, {renderOptions:{map: map,autoViewport: true}});
                driving.search(point1, point2);
                let myIcon1 = new BMap.Icon(start, new BMap.Size(30,45));
                let myIcon2 = new BMap.Icon(end, new BMap.Size(30,45));
                driving.setMarkersSetCallback(function(result){
                    result[0].marker.setIcon(myIcon1);
                    result[1].marker.setIcon(myIcon2);
                })
                var output;
                var searchComplete = function (results){
                    var plan = results.getPlan(0);
                    output = plan.getDistance(true);             //获取距离
                }
                var distance;
                var transit = new BMap.DrivingRoute(map, {renderOptions: {map: map},
                    onSearchComplete: searchComplete,
                    onPolylinesSet: function(){        
                        distance = output
                }});
                transit.search(point1, point2);
                transit.setMarkersSetCallback(function(result){
                    result[0].marker.setIcon(myIcon1);
                    result[1].marker.setIcon(myIcon2);
                })
                setTimeout(() => {
                    let opts = {
                        position : point1,    // 指定文本标注所在的地理位置
                        offset   : new BMap.Size(30, -30)    //设置文本偏移量
                      }
                    let label = new BMap.Label(`<span style='color:#616372;padding-right:8px'>全程</span>`+ distance.slice(0, -2) + `<span style='color:#303030;padding-left:8px'>公里</span>`, opts);  // 创建文本标注对象
                    label.setStyle({
                        color : "#3679FE",
                        fontSize : "14px",
                        height : "20px",
                        lineHeight : "20px",
                        fontFamily:"微软雅黑",
                        borderRadius:"20px",
                        border:'none',
                        padding:'5px 10px',
                        boxShadow:'0px 3px 6px rgba(0,0,0,0.2)'
                    });
                    map.addOverlay(label);   
                }, 1001);
               
            }
        }, 1000);
    }
    convertjwd(lat,lng,type,callback){
        let params = {
            token:this.props.userInfo.token,
            data:{
                position:lat+'_'+lng,
                type:type,
            }
        }
        translate(params).then((res) => {
            if (res.data.code === '0000') {
                return callback(res.data.data)
            }else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }else {
                Toast.info(res.data.msg);
            }
        })
    }
    orderSend = () => {
        let params = {
            token: this.props.userInfo.token,
            data: {
                id: this.props.location.state.id
            }
        }
        orderSend(params).then((res) => {
            console.log(res)
            if(res.data.code == "0000"){
              this.setState({
                 showModal:true
              })
            }else {
                Toast.info(res.data.msg,3)
            }
            }).catch(function (error) {
            console.log(error);
        });
    }
    delete = () =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "shuntOrderid":this.props.location.state.id,
                "operatorType": 1,
                "isCharge":1
            }
         };
         cancleCity(params)
             .then((res) => {
                 console.log(res)
                 if (res.data.code === '0000') {
                    Toast.info('关闭成功',2, window.location.reload());
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
             }).catch(function (error) {
             console.log(error);
         });
    };
    render() {
        const {data} = this.state;
        return (
            <div className="citybill">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<div className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >派单预览</NavBar>
                <div className="address">
                {
                    this.state.show ?  
                        <div className="location">
                            <div className="line"><span className="preOrder">{data.cityorderType === 0 ? '实时订单':'预约订单'}</span><div>已拒单：<span>{data.denyCount}次</span></div></div>
                            <div className="send">
                                <div><i className="icon iconfont icondaixiadanchufadi"></i>{data.startAddress}</div> 
                            </div>
                            <div className="deliver">
                                <div><i className="icon iconfont icondaixiadanmudedi"></i>{data.endAddress}</div>
                            </div>
                            <div>
                                <div className="startTime">{data.estimatedTimeOfDeparture}</div>
                                <div className="money">费用预估<div>¥{data.theoryPrice}</div></div>
                            </div>
                        </div>
                       
                    :null
                }
                   
                    
                              
                    <div className="spread" onClick={()=>this.setState({show:!this.state.show})}>
                        {this.state.show ? <i className="icon iconfont iconzhedie"></i> : <i className="icon iconfont iconzhankai"></i> }
                    </div>
                </div>
                <div  id="allmap"></div>
                <div className="footerContent">
                  <div onClick={()=>this.setState({modal:true})}>发单</div>
                  <div onClick={()=>this.props.history.push('/drivers',{type:'city',id:this.props.location.state.id})}>派单</div>
                  <div onClick={()=>this.setState({closeModal:true})}>关闭订单</div>
                </div> 
                <Modal
                    className="billViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '知道了', onPress: () => { this.setState({showModal:!this.state.showModal}); this.props.history.goBack()} }]}
                >
                <div className="modalTitle">
                    <div>发单成功!</div>
                    <div>司机抢单中，请及时关注抢单进度</div>
                </div>
                </Modal>
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.modal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '取消', onPress: () => { this.setState({modal:!this.state.modal}); } },{ text: '确定', onPress: () => { this.setState({modal:!this.state.modal});this.orderSend() } }]}
                >
                    <div className="modalTitle">
                        <div>是否确认发单？</div>
                    </div>
                </Modal>
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.closeModal}
                    transparent
                    closable
                    maskClosable={true}
                    onClose={()=>this.setState({closeModal:false})}
                    footer={[{ text: '否', onPress: () => {this.setState({closeModal:!this.state.closeModal});}},{ text: '是', onPress: () => { this.setState({closeModal:!this.state.closeModal});this.delete()}}]}
                >
                    <div className="modalTitle">
                        <div>是否关闭订单？</div>
                    </div>
                </Modal> 
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/City/CityBill/index.js